<template>
  <div id="booking-process" :class="`${summaryMode ? 'sidebarVisible' : 'sidebarCollapsed'}`">
    <datepicker
      ref="datepicker"
      :productId="productId"
      :moduleCollapsed="moduleCollapsed('datepicker')"
      @next-started="showModule('roomResults')"
      @failed="showModule('datepicker')"
      @next-loaded="assignRoomResults"
      @flight-mode-changed="setShowFlightSteps"
      @enable-sidebar="summaryEnabled = true"
      @section-clicked="stepBackFrom">
    </datepicker>

    <room-results
      ref="roomResults"
      :productId="productId"
      :moduleCollapsed="moduleCollapsed('roomResults')"
      :result="roomResults"
      :is-vp-mode="isVpMode"
      @next-started="showModule"
      @next-loaded="assignRoomSelection"
      @section-clicked="stepBackFrom"
      @step-back="stepBackFrom"
      @failed="showModule('datepicker')"
      v-if="moduleVisible('roomResults')">
    </room-results>
    <booking-section :preview="true" :title="$t('booking.sectionTitles.roomResults')" v-else></booking-section>

    <flight-results
      ref="flightResults"
      :productId="productId"
      :moduleCollapsed="moduleCollapsed('flightResults')"
      :result="flightResults"
      :is-vp-mode="isVpMode"
      @next-started="isVpMode || true ? showModule('services') : showModule('leadForm')"
      @next-loaded="assignProceedAfterFlight"
      @section-clicked="stepBackFrom"
      @failed="showModule('datepicker')"
      v-if="moduleVisible('flightResults')">
    </flight-results>
    <booking-section :preview="true" :title="$t('booking.sectionTitles.flightResults')" v-else-if="showFlightSteps"></booking-section>


    <template v-if="isVpMode || true ">
      <services
        ref="services"
        :productId="productId"
        :moduleCollapsed="moduleCollapsed('services')"
        :result="serviceResults"
        :services-enabled="isInternal"
        @next-started="showModule('checkout')"
        @update-summary="updateSummary"
        @next-loaded="assignCheckoutResults"
        @section-clicked="stepBackFrom"
        @failed="showModule('datepicker')"
        v-if="moduleVisible('services')">
      </services>
      <booking-section :preview="true" :title="$t('booking.sectionTitles.services')" v-else></booking-section>
    </template>

    <template v-if="moduleVisible('leadForm') || moduleVisible('checkout')">
      <lead-form
        ref="leadForm"
        :productId="productId"
        :moduleCollapsed="moduleCollapsed('leadForm')"
        :result="flightDetails || serviceResults"
        
        @next-started="showModule('checkout')"
        @update-summary="updateSummary"
        @next-loaded="assignCheckoutResults"
        @section-clicked="stepBackFrom"
        v-if="moduleVisible('leadForm')">
      </lead-form>

      <checkout
        ref="checkout"
        :productId="productId"
        :result="checkoutResults"
        v-if="moduleVisible('checkout')">
      </checkout>
    </template>
    <booking-section :preview="true" :title="$t('booking.sectionTitles.checkout')" v-else></booking-section>

    <summary-sidebar
      :summary="summary"
      :currentPrice="currentPrice"
      @toggle-summary="summaryVisible = !summaryVisible"
      @section-clicked="stepBackFrom"
      v-if="summaryEnabled">
    </summary-sidebar>

    <div id="booking-error-overlay" class="reveal-overlay hide-in-sales">
      <div class="inner">
        <h3 class="text-center">Ihre Buchungsanfrage konnte leider nicht bearbeitet werden</h3>
        <div class="error-content"></div>
        <div class="text-center"><a class="cta cta--secondary cta--small cta--inline" @click="hideErrorMessage()">Meldung schließen</a></div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['productId', 'locale'],
  components: {
    datepicker: () => import('../booking/datepicker.vue'),
    roomResults: () => import('../booking/roomResults.vue'),
    leadForm: () => import('../booking/leadForm.vue'),
    flightResults: () => import('../booking/flightResults.vue'),
    flightDetails: () => import('../booking/flightDetails.vue'),
    services: () => import('../booking/services.vue'),
    checkout: () => import('../booking/checkout.vue'),
    summarySidebar: () => import('../booking/summarySidebar.vue'),
    bookingSection: () => import('../shared/bookingSection.vue')
  },
  data: function () {
    return {
      visible: ['datepicker'],
      collapsed: [],
      roomResults: null,
      flightResults: null,
      flightDetails: null,
      serviceResults: { calculation_data: [] },
      checkoutResults: null,
      currentModule: 'datepicker',
      summary: [
        { name: 'Reisedaten', section: 'datepicker', infos: ['Bitte wählen Sie:', 'Reisezeitraum, Personen', 'Verpflegung und Flug']}
      ],
      summaryVisible: true,
      summaryEnabled: false,
      currentPrice: null,
      showFlightSteps: true,
      bookingSectionY: 0
    }
  },
  computed: {
    prevModule(){
      const i = (this.visible.findIndex(e => e == this.currentModule) - 1)
      if (i >= 0){
        return this.visible[i]
      }
    },
    summaryMode(){
      return (this.summaryVisible && this.summaryEnabled)
    },
    isVpMode(){
      if (this.roomResults && this.roomResults.global){
        return this.roomResults.global.vp_ref != null
      }
    },
    isInternal(){
      return window.salesInternal == true
    }
  },
  mounted(){
    this.summaryVisible = ($(window).width() > 800)


    var bookingButtons = $("#booking-button-widget-scroller")
    var bookingButtonOffsetY = bookingButtons.offset().top
    setBookingSectionY()

    document.addEventListener("scroll", (event) => {
      var y = window.scrollY;

      if (y+400 > window.bookingSectionY){
        if (!bookingButtons.hasClass("hidden")){
          bookingButtons.addClass("hidden")
        }
      }else{
        if (bookingButtons.hasClass("hidden")){
          bookingButtons.removeClass("hidden")
        }
      }

      if (y > bookingButtonOffsetY){
        if (!bookingButtons.hasClass("fixed")){
          bookingButtons.addClass("fixed")
        }
      }else{
        if (bookingButtons.hasClass("fixed")){
          bookingButtons.removeClass("fixed")
        }
      }


    });



  },
  watch: {
    summaryMode() {
      if (this.summaryMode == true){
        $('body').addClass('summarySidebarVisible')
      }else {
        $('body').removeClass('summarySidebarVisible')
      }
    }
  },
  methods: {
    moduleVisible(modName){
      return (this.visible && this.visible.findIndex(v => v == modName) != -1)
    },
    moduleCollapsed(modName){
      return (this.currentModule != modName && (this.collapsed && this.collapsed.findIndex(v => v == modName) != -1))
    },
    showModule(modName){
      if (!this.moduleVisible(modName)){
        this.visible.push(modName)
      }
      this.hideModuleAfter(modName)
      this.collapseModuleBefore(modName)

      //this.uncollapseModule(modName)
      this.currentModule = modName

      if (modName == 'roomResults'){
        this['roomResults'] = null
        this['flightResults'] = null
      }
    },
    setShowFlightSteps(val){
      this.showFlightSteps = val
    },
    assignRoomResults(results){
      this.assignResultsTo('roomResults', results)
    },
    assignRoomSelection(type, data){
      if (type == 'flight'){
        this.assignResultsTo('flightResults', data)
      }else{
        this.assignServiceResults(data)
      }
    },

    assignProceedAfterFlight(data){
      if (this.isVpMode || true){
        this.assignServiceResults(data)
      }else{
        this.assignFlightDetails(data)
      }
    },

    assignFlightDetails(data){
      this.assignResultsTo('flightDetails', data)
    },
    assignServiceResults(data){
      console.log(data)
      this.assignResultsTo('serviceResults', data)
    },
    assignCheckoutResults(data){
      this.assignResultsTo('checkoutResults', data)
    },
    assignResultsTo(resName, data){
      this[resName] = data
      this.updateSummary(data)
    },
    updateSummary(data){
      this.summary = data.global.summary
      this.currentPrice = data.global.price
    },
    hideModuleAfter(modName){
      const i = this.visible.findIndex(e => e == modName)
      if (i != -1){
        this.visible.splice(i+1, this.visible.length-1)
      }
    },
    collapseModuleBefore(modName){
      // check index of current visible entry to find entry that are before given entry
      const currendVisIndex = this.visible.findIndex(e => e == modName)

      // iterate all visible entries to get the ones before given entry
      this.visible.forEach((visibleMod,i) => {
        const isBeforeGiven = (this.visible.findIndex(e => e == visibleMod) < currendVisIndex)


        if (isBeforeGiven){
          // check if not already collapsed
          const curCollapsedInd = this.collapsed.findIndex(col => col == visibleMod)
          if (curCollapsedInd == -1){
            this.collapsed.push(visibleMod)
          }
        }
      })
    },
    uncollapseModule(modName){
      const i = this.collapsed.findIndex(col => col == modName)

      this.collapsed.splice(i, 1)
    },
    stepBackFrom(currentStep){
      //if (this.prevModule){
      this.showModule(currentStep)
        //}

      // trigger required data loader actions
      switch(currentStep){
        case 'roomResults':
          // when showing room-results, data gets loaded from datepicker
          this.$refs.datepicker.loadResults(false)
      }

      $('html, body').animate({
        scrollTop: $(this.$refs[currentStep].$el).offset().top
      })
    },
    hideErrorMessage(){
      $('#booking-error-overlay').hide()
    }
    
  }
}
</script>

<style lang="scss" scoped>
  
</style>
